import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "singularize",
  standalone: false,
})
export class SingularizePipe implements PipeTransform {
  transform(value: string | undefined | null): string {
    if (!value) return "";
    // Basic English pluralization rules (for demonstration)
    if (value.endsWith("ies")) {
      return value.slice(0, -3) + "y";
    }
    if (value.endsWith("ses") || value.endsWith("xes") || value.endsWith("zes")) {
      return value.slice(0, -2);
    }
    if (value.endsWith("s") && !value.endsWith("ss")) {
      return value.slice(0, -1);
    }
    return value;
  }
}
